import { getDeterministicImage } from 'helpers/image-helper';
import { imagify } from 'server/routes/seo/helpers';
import { PropTypes } from 'prop-types';
import React from 'react';


export default function Top({ alt, estabFallbackImages, href, id, image, isFollow }) {

  const fallbackImage = getDeterministicImage(id, estabFallbackImages);
  const altAttribute = alt ? `alt="${alt.split('\n').join('').split('\t').join('')}"` : '';
  const node = `
    <div class="establishment-card__top">
      <a class="establishment-card__top__carrousel" href="${href}" rel="${isFollow ? '' : 'nofollow'}" target="_blank" >
        <img class="establishment-card__top__carrousel__image" src="${imagify(image, 1200)}" lazyload="on" onerror="this.error=null;this.src='${fallbackImage}';" ${altAttribute} />
      </a>
    </div>
  `;
  return (<div dangerouslySetInnerHTML={ { __html: node } } />);
}

Top.defaultProps = {
  alt: '',
};

Top.propTypes = {
  alt: PropTypes.string,
  estabFallbackImages: PropTypes.arrayOf(PropTypes.string).isRequired,
  href: PropTypes.string.isRequired,
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  image: PropTypes.string.isRequired,
  isFollow: PropTypes.bool.isRequired,
};
